module.exports = __webpack_public_path__ + "static/media/pt.70a47eed.svg";